import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  truncatedText: {
    cursor: 'pointer'
  },
  tooltipLabel: {
    width: '100%'
  },
  tooltip: {
    backgroundColor: theme.colorPalette.green_75
  }
}));

export default useStyles;
